import React, { useContext } from "react";
// import FadeIn from "react-lazyload-fadein";
import A from "@vahak/core/dist/components/app-anchor/A";
import AppBtn from "@vahak/core/dist/components/app-btn/AppBtn";
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";
import { AppContext } from "@vahak/core/dist/app-context";
import AppImg from "../../utils/AppImg";
import Style from "./CTABanner.module.scss";
import { useTranslation } from "next-i18next";
interface CTABannerProps {
    href: string;
    title: string;
}

const CTABanner = ({ href, title }: CTABannerProps) => {
    const { isMobile } = useContext(AppContext);
    const { t } = useTranslation(["common", "transporters"]);

    return (
        <div className={Style.ctaBannerWrap}>
            <div>
                <A href={href} title={title} openInNewTab>
                    <div className={Style.ctaBanner} style={{ position: "relative", width: "100%" }}>
                        <AppImg
                            id="ctaImage"
                            src={"bottom_banner_background_web.png"}
                            // srcSet={`${ctaBgrLarge} 992w , ${ctaBgSmall} 768w`}
                            className={Style.CtaImage}
                            alt={t("transporters:bottom_cover.heading")}
                            width="1440"
                            height="349"
                        />
                        <div
                            className="container"
                            style={{ position: "absolute", bottom: isMobile ? "-5px" : "-12px" }}
                        >
                            <div className={Style.ctaRow}>
                                <div className={Style.ctaCol}>
                                    <div className={Style.text}>
                                        <h3>{t("transporters:bottom_cover.title")}</h3>
                                        <h2>{t("transporters:bottom_cover.sub_title")}</h2>

                                        <AppBtn className={Style.ctaButton}>
                                            {t("transporters:bottom_cover.button_cta")}
                                            <ArrowRightWhite />
                                        </AppBtn>
                                    </div>
                                </div>
                                <div className={Style.ctaCol}>
                                    <div className={Style.imgBox}>
                                        <AppImg
                                            src="bottom_banner_foreground_website.png"
                                            // srcSet={`${ctaFgLarge} 992w, ${ctaFgSmall} 768w`}
                                            alt={t("transporters:bottom_cover.heading")}
                                            height="546"
                                            width="458"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </A>
            </div>
        </div>
    );
};

export default CTABanner;
